<template>
  <div>
    <pcHeader></pcHeader>
    <div v-for="(item,index) in allData" :key="index" v-if="item.parentName=='banner'">
      <div v-if="item.content.length>0&&item.content!==undefined&&item.content!==null" class="pc_banner_box">
        <el-carousel :interval="3000" arrow="" style="width: 100%;height: 100%">
          <el-carousel-item v-for="(val,idx) in item.content" :key="idx" style="width: 100%;height: 100%;margin:0 auto;background:#fff;text-align: center;cursor: pointer;">
            <img :data-idx="index" :data-status="val.status" @click="goto(val)" :data_id="item.id" :src="val.pic?val.pic:noImg" style="height:100%;" alt="">
          </el-carousel-item>
        </el-carousel>
      </div>
    </div>
    <div class="pc_index_content">
      <div v-for="(item,index) in allData" :key="index" v-if="item.parentName=='recommend'||item.parentName=='recommendCope_1'||item.parentName=='recommendCope_2'">
        <div v-if="item.content.length>0&&item.content!==undefined&&item.content!==null" class="pc_recommend_box clearfix_">
          <div v-for="(val,idx) in item.content" :key="idx" @click="goto(val)" class="pc_recommend_item fl">
            <div class="pc_recommend_item_img"><img :src="val.pic?val.pic:noImg" alt=""></div>
            <div class="pc_recommend_item_txt">
              <div class="pc_recommend_item_title">{{val.title}}</div>
              <div class="pc_recommend_item_decorate"></div>
              <div class="pc_recommend_item_remark">{{val.remark}}</div>
            </div>
          </div>
        </div>
      </div>
      <div v-for="(item,index) in allData" :key="'goods1'+index" v-if="item.parentName=='newShopp'||item.parentName=='newShoppCope_1'||item.parentName=='newShoppCope_2'">
        <div v-if="item.goods.length>0&&item.goods!==undefined&&item.goods!==null" class="pc_goods1_box clearfix_">
          <div class="pc_goods1_title clearfix_">
            <div class="fl pc_goods1_title_txt1">{{item.title}}</div>
            <div class="fr pc_goods1_title_txt2">{{item.remark}}</div>
          </div>
          <div class="pc_goods1_list clearfix_">
             <div @click="gotoGoodsDetail(val)" v-for="(val,idx) in item.goods" :key="idx" class="pc_goods1_item fl">
              <div class="pc_goods1_item_img"><img :src="val.pic?val.pic:noImg" alt=""></div>
              <div class="pc_goods1_item_bg">
                <div class="pc_goods1_item_name">{{val.name}}</div>
                <div class="pc_goods1_item_price">价格： {{val.price}}</div>
                <div class="pc_goods1_item_btn">购买</div>
              </div>
              <div v-if="val.activityContent" class="pc_goods1_activity">
                <div class="pc_goods1_activity_img"><img :src="val.activityPic" alt=""></div>
                <div class="pc_goods1_activity_txt">{{val.activityContent}}</div>
              </div>
            </div> 
          </div>
        </div>
      </div>
      <div v-for="(item,index) in allData" :key="'goods2'+index" v-if="item.parentName=='newShopp_2'||item.parentName=='newShopp_2Cope_1'||item.parentName=='newShopp_2Cope_2'">
        <div v-if="item.goods.length>0&&item.goods!==undefined&&item.goods!==null" class="pc_goods2_box clearfix_">
          <div class="pc_goods1_title clearfix_">
            <div class="fl pc_goods1_title_txt1">{{item.title}}</div>
            <div class="fr pc_goods1_title_txt2">{{item.remark}}</div>
          </div>
          <div class="pc_goods2_list clearfix_">
            <div @click="gotoGoodsDetail(val)" v-for="(val,idx) in item.goods" :key="idx" class="pc_goods2_item fl">
              <div class="pc_goods2_item_img">
                <img :src="val.pic?val.pic:noImg" alt="">
                <div v-if="val.activityContent" class="pc_goods1_activity">
                  <div class="pc_goods1_activity_img"><img :src="val.activityPic" alt=""></div>
                  <div class="pc_goods1_activity_txt">{{val.activityContent}}</div>
                </div>
              </div>
              <div class="pc_goods2_item_name">{{val.name}}</div>
              <div class="pc_goods2_item_price">
                ¥{{val.price}} <i v-if="val.price!=val.lrprice">¥{{val.lrprice}}</i>
              </div>
              <div class="pc_goods2_item_btn">购买</div>
            </div>
          </div>
        </div>
      </div>
      <div v-for="(item,index) in allData" :key="'goods3'+index" v-if="item.parentName=='hotShopp'||item.parentName=='hotShoppCope_1'||item.parentName=='hotShoppCope_2'||item.parentName=='hotShopp_2'||item.parentName=='hotShopp_2Cope_1'||item.parentName=='hotShopp_2Cope_2'">
        <div v-if="item.goods.length>0&&item.goods!==undefined&&item.goods!==null" class="pc_goods3_box clearfix_">
          <div class="pc_goods1_title clearfix_">
            <div class="fl pc_goods1_title_txt1">{{item.title}}</div>
            <div class="fr pc_goods1_title_txt2">{{item.remark}}</div>
          </div>
          <div class="pc_goods3_list clearfix_">
            <div @click="goto(item.content[0])" class="fl pc_goods3_img"><img :src="item.content[0].pic?item.content[0].pic:noImg" alt=""></div>
            <div @click="gotoGoodsDetail(val)" v-for="(val,idx) in item.goods" :key="idx" class="pc_goods3_item fl">
              <div class="pc_goods3_item_img">
                <img :src="val.pic?val.pic:noImg" alt="">
                <div v-if="val.activityContent" class="pc_goods1_activity">
                  <div class="pc_goods1_activity_img"><img :src="val.activityPic" alt=""></div>
                  <div class="pc_goods1_activity_txt">{{val.activityContent}}</div>
                </div>
              </div>
              <div class="pc_goods2_item_name">{{val.name}}</div>
              <div class="pc_goods2_item_price">
                ¥{{val.price}} <i v-if="val.price!=val.lrprice">¥{{val.lrprice}}</i>
              </div>
              <div class="pc_goods2_item_btn">购买</div>
              <div></div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <pcBackTop></pcBackTop>
  </div>
</template>
<style>
.pc_banner_box{
  width: 100%;
  height: 540px;
}
.el-carousel .el-carousel__container{
  width: 100%;
  height: 100%;
}
.el-carousel__item h3 {
  color: #475669;
  font-size: 18px;
  opacity: 0.75;
  line-height: 300px;
  margin: 0;
}
.el-carousel__item:nth-child(2n) {
  background-color: #99a9bf;
}
.el-carousel__item:nth-child(2n+1) {
  background-color: #d3dce6;
}
.pc_index_content{
  width: 100%;
  background: #f5f5f5;
  padding-top: 50px;
  padding-bottom: 1px;
  margin-bottom: 15px;
}
.pc_recommend_box{
  width: 1200px;
  margin: 0 auto;
  margin-bottom: 50px;
}
.pc_recommend_item{
  width: 279px;
  height: 185px;
  margin-right: 27px;
  position: relative;
  cursor: pointer;
}
.pc_recommend_item:last-child{
  margin-right: 0;
}
.pc_recommend_item:hover .pc_recommend_item_txt{
  display: block;
}
.pc_recommend_item_img{
  width: 279px;
  height: 185px;
}
.pc_recommend_item_img img{
  width: 279px;
  height: 185px;
}
.pc_recommend_item_txt{
  width: 215px;
  height: 86px;
  background: hsla(0,0%,93%,.7);
  position: absolute;
  top: 58px;
  left: 32px;
  padding-top: 35px;
  color: #975b31;
  display: none;
}
.pc_recommend_item_title{
  width: 100%;
  text-align: center;
  margin-bottom: 11px;
  font-family: '微软雅黑';
  font-size: 22px;
}
.pc_recommend_item_decorate{
  width: 111px;
  height: 2px;
  background: #975b31;
  margin: 0 0 11px 52px;
}
.pc_recommend_item_remark{
  padding: 0 10px;
  text-align: center;
  font-size: 12px;
  overflow: hidden;
  text-overflow:ellipsis;
  white-space: nowrap;
}
.pc_goods1_box{
  width: 1200px;
  margin: 0 auto;
  margin-bottom: 50px;
}
.pc_goods1_title{
  width: 100%;
  height: 48px;
  border-bottom: 1px solid #dedede;
  margin-bottom: 25px;
}
.pc_goods1_title_txt1{
  color: #f56815;
  font-size: 28px;
  font-weight: 900;
}
.pc_goods1_title_txt2{
  color: #bbb;
  font-size: 12px;
  margin-top: 25px;
}
.pc_goods1_item{
  width: 284px;
  height: 284px;
  margin-right: 21px;
  position: relative;
  cursor: pointer;
}
.pc_goods1_item:last-child{
  margin-right: 0;
}
.pc_goods1_item:hover .pc_goods1_item_bg{
  display: block;
}
.pc_goods1_item_img{
  width: 284px;
  height: 284px;
}
.pc_goods1_item_img img{
  width: 284px;
  height: 284px;
}
.pc_goods1_item_bg{
  width: 284px;
  height: 173px;
  background: rgba(0,0,0,.5);
  position: absolute;
  top: 0;
  left: 0;
  padding-top: 111px;
  display: none;
}
.pc_goods1_item_name{
  color: #fff;
  text-align: center;
  width: 80%;
  min-height: 32px;
  margin: 0 auto;
  margin-bottom: 10px;
  line-height: 16px;
}
.pc_goods1_item_price{
  text-align: center;
  color: #fff;
  margin-bottom: 10px;
}
.pc_goods1_item_btn{
  width: 68px;
  height: 28px;
  border: 1px solid #fff;
  color: #fff;
  border-radius: 2px;
  cursor: pointer;
  background: transparent;
  margin: 0 auto;
  line-height: 28px;
  text-align: center;
}
.pc_goods1_item_btn:hover{
  border: 1px solid #fa0;
  background: #fa0;
}
.pc_goods2_box{
  width: 1200px;
  margin: 0 auto;
  margin-bottom: 50px;
}
.pc_goods2_list{
  width: 1200px;
}
.pc_goods2_item{
  width: 284px;
  margin-right: 21px;
  background: #fff;
  padding-bottom: 12px;
}
.pc_goods2_item:last-child{
  margin-right: 0;
}
.pc_goods2_item_img{
  width: 284px;
  height: 284px;
  margin-bottom: 12px;
  position: relative;
  overflow: hidden;
}
.pc_goods2_item_img>img{
  width: 284px;
  height: 284px;
  transition: .8s;
}
.pc_goods2_item_img>img:hover{
  width: 314px;
  height: 314px;
  margin: -15px 0 0 -15px;
  transition: .8s;
}
.pc_goods2_item_name{
  padding: 0 15px;
  line-height: 18px;
  height: 40px;
  text-align: center;
  border-bottom: 1px dashed #ccc;
  display: -webkit-box;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 2;
  overflow: hidden;
  margin-bottom: 12px;
}
.pc_goods2_item_price{
  color: #fa0;
  font-size: 16px;
  text-align: center;
  margin-bottom: 12px;
}
.pc_goods2_item_price i{
  color:#767676;
  font-size:12px;
  text-decoration: line-through;
}
.pc_goods2_item_btn{
  width: 200px;
  height: 33px;
  line-height: 33px;
  font-size: 14px;
  text-align: center;
  background: #fb0;
  color: #fff;
  border-radius: 3px;
  cursor: pointer;
  margin: 0 auto;
}
.pc_goods3_box{
  width: 1200px;
  margin: 0 auto;
  margin-bottom: 50px;
}
.pc_goods3_list{
  width: 1200px;
}
.pc_goods3_img{
  width: 588px;
  height: 423px;
  margin-right: 23px;
}
.pc_goods3_img img{
  width: 588px;
  height: 423px;
}
.pc_goods3_item{
  width: 284px;
  margin-right: 21px;
  background: #fff;
  padding-bottom: 10px;
  margin-bottom: 10px;
}
.pc_goods3_item:last-child,.pc_goods3_item:nth-child(3){
  margin-right: 0;
}
.pc_goods3_item_img{
  width: 284px;
  height: 284px;
  margin-bottom: 15px;
  position: relative;
  overflow: hidden;
}
.pc_goods3_item_img>img{
  width: 284px;
  height: 284px;
  transition: .8s;
}
.pc_goods3_item_img>img:hover{
  width: 314px;
  height: 314px;
  margin: -15px 0 0 -15px;
  transition: .8s;
}
.pc_goods1_activity{
  width: 100%;
  position: absolute;
  left: 0;
  bottom: 0;
}
.pc_goods1_activity_img{
  width: 100%;
}
.pc_goods1_activity_img img{
  width: 100%;
}
.pc_goods1_activity_txt{
  width: 100%;
  font-size: 14px;
  color: #fff;
  text-align: center;
  position: absolute;
  bottom: 10px;
  left: 0;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
</style>
<script>
import axios from 'axios'
import Qs from 'qs'
import { ip,overtime } from '../../assets/js/public.js'
import pcHeader from '@/components/index/search'
import pcBackTop from '@/components/common/BackTop'
export default {
  components:{
    pcHeader,pcBackTop
  },
  data(){
    return {
      allData:[],
      noImg:require("@/assets/img/aa.png"),
    }
  },
  mounted:function(){
    this.getAllData()
    this.getfooter()
  },
  methods:{
    go404:function(msg){
      var href=this.$router.resolve({name:'err404',query:{txt:msg}})
      return window.open(href.href,'_blank')
    },
    goSignIn:function(){
      localStorage.removeItem('tamp')
      localStorage.removeItem('name')
      return this.$router.push({
        name: 'loginHome',
        query: {redirect: this.$route.fullPath,oldRoter:this.$route.path,oldData:this.$route.query}
      });
    },
    getfooter:function () {
      var t_=this
      let data = Qs.stringify({"AreaAlias":'footerText',"channel":2,tamp:localStorage.tamp?localStorage.tamp:''});
      axios.post(`${ip}formWorkInterface/getWXBottom`,data).then(res => {
        if(overtime(res.data.code))return t_.goSignIn()
        if(res.data.code==300)return t_.go404(res.data.message)
        if(res.data.code==0){
          // t_.$store.commit('getIndexBottomHtml',res.data)
          localStorage.setItem('pcFooterData',JSON.stringify(res.data))
        }
      })
    },
    gotoGoodsDetail:function(obj){
      var href=this.$router.resolve({name:'goodsdetails',query:{goodsId:obj.id,isSupplyChainGoods:2,supplyChainTenantId:obj.supplyChainTenantId}})
      window.open(href.href,'_blank')
    },
    getAllData:function(){
      var t_=this
      let data = Qs.stringify({
        channel:2,
        tamp:localStorage.tamp?localStorage.tamp:''
      });
      axios.post(`${ip}formWorkInterface/allArea`, data).then(res => {
        if(overtime(res.data.code))return t_.goSignIn()
        if(res.data.code==300)return t_.go404(res.data.message)
        if(res.data.code==0){
          t_.$store.commit('getContact1',res.data.qq)
          t_.$store.commit('getContact2',res.data.telephone)
          // t_.$store.commit('indexAllData',res.data.results)
          localStorage.setItem('indexAllData',JSON.stringify(res.data.results))
          t_.allData=res.data.results
        }
      })
    },
    goto:function(obj){
      var t_ = this
      if( obj.status==1 ){
        if(obj.atriceId=='')return
        var href=this.$router.resolve({
          name:'articleList',
          query: {
            id: obj.atriceId
          }
        })
        window.open(href.href,'_blank')
      }else if(obj.status==2){
        var href=this.$router.resolve({
          name:'goodslist',
          query: {
            id: obj.categoryId
          }
        })
        window.open(href.href,'_blank')
      }else if(obj.status==3){
        var href=this.$router.resolve({
          name:'goodslist',
          query: {
            txt: obj.search
          }
        })
        window.open(href.href,'_blank')
      }else if(obj.status==5){
        //window.location.open = obj.link
        window.open(obj.link)
      }else if(obj.status==6){
        var href=t_.$router.resolve({
          name:'goodsdetails',
          query:{
            goodsId:obj.goodsId,
            isSupplyChainGoods:2,
            supplyChainTenantId:obj.supplyChainTenantId
          }
        })
        window.open(href.href,'_blank')
      }else if(obj.status==4){
        var href=t_.$router.resolve({
          name:obj.formwordPcLocal,
          query:{
            id:obj.formwordId
          }
        })
        window.open(href.href,'_blank')
      }else if(obj.status==9){
        if(obj.module==1){
          var href=this.$router.resolve({name:'teamGoods'});
          window.open(href.href,'_blank')
        }else if(obj.module==3){
          var href=this.$router.resolve({name:'couponList'});
          window.open(href.href,'_blank')
        }else if(obj.module==5){
          var href=this.$router.resolve({name:'activityList'});
          window.open(href.href,'_blank')
        }else if(obj.module==6){
          var href=this.$router.resolve({name:'scoreChange'});
          window.open(href.href,'_blank')
        }
      }
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/index/index.vue